// getCurrentUserLevel.js
'use strict';

/**
 * Get current user level
 * @param {object} levelData - level name and exp data.
 * @param {number} unixTimestamp - timestamp to compaire with.
 * @returns {string|number} {level} current level key in level data.
 */
const getCurrentUserLevel = ({ levelData, unixTimestamp }) => {
  if (!levelData || !unixTimestamp) return null;

  // Level data from pusher will be number, like 100 or 80.
  // Level data from `users/{id}` will be object, like {100: {nbf: 1767196800, exp: 1777564799}}.
  if (typeof levelData === 'number') {
    return levelData;
  }

  const maxCurrentLevel = Object.keys(levelData).reduce((maxLevel, level) => {
    // not expired
    if (levelData[level]?.exp - unixTimestamp > 0) {
      return Math.max(maxLevel, level);
    }
    return maxLevel;
  }, 0);

  return maxCurrentLevel;
};

export default getCurrentUserLevel;
